import React from "react";
import LegalMarkdownPage from "./LegalMarkdownPage";

import termsEnglish from "../docs/legal/terms-of-service/terms.en.md"; //
import termsFrench from "../docs/legal/terms-of-service/terms.fr.md";
import termsArabic from "../docs/legal/terms-of-service/terms.ar.md";
import termsSpanish from "../docs/legal/terms-of-service/terms.en.md";
import termsItalian from "../docs/legal/terms-of-service/terms.en.md";

import "../styles/LegalPages.css";

const termsDocuments = {
  en: termsEnglish,
  fr: termsFrench,
  ar: termsArabic,
  es: termsSpanish,
  it: termsItalian,
};

const TermsOfService = () => {
  return (
    <LegalMarkdownPage
      documents={termsDocuments}
      containerClassName="legal-page-container"
      headingClassName="legal-page-heading"
      errorMessage="The Terms of Service could not be loaded."
    />
  );
};

export default TermsOfService;
